import { fmtClock } from '../lib/format.js';

export function ShiftPill({ shift, onClick, onDragStart, onDragEnd, draggable = false }) {
  const isSquare = shift.source === 'square';
  const hasWarn = shift.warnings && shift.warnings.length > 0;
  const isPublished = shift.status === 'published';
  // Drafts render faded with a dashed border + diagonal stripes so a
  // manager can tell at a glance which shifts haven't been pushed yet
  // ("not published" = lower visual weight). Published shifts go full
  // saturation. Square-pulled shifts (always already-published when we
  // see them) keep their grey treatment but get the same full-color
  // bump so they don't look like drafts.
  const baseBg = isSquare ? '#eceff1' : '#e8f5e9';
  const fg     = isSquare ? '#37474f' : '#1b5e20';
  const baseBorder = hasWarn ? '#f9a825' : (isSquare ? '#cfd8dc' : '#a5d6a7');
  const draftStripe = `repeating-linear-gradient(135deg, ${baseBg}, ${baseBg} 4px, rgba(255,255,255,0.55) 4px, rgba(255,255,255,0.55) 8px)`;
  return (
    <div onClick={(e) => { e.stopPropagation(); onClick(); }}
      draggable={draggable}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      title={[
        isPublished ? 'Published' : 'Draft — not yet published',
        draggable ? 'Drag to move (Alt/Option to copy)' : '',
        hasWarn ? shift.warnings.map((w) => w.kind === 'full_day_off' ? `Off all day${w.note ? ` (${w.note})` : ''}`
          : w.kind === 'outside_availability' ? `Outside their available hours (${w.range})`
          : `Time-range conflict ${w.range}`).join('; ') : '',
      ].filter(Boolean).join(' · ')}
      style={{
        background: isPublished ? baseBg : draftStripe,
        color: fg,
        padding: '3px 6px',
        borderRadius: 4,
        fontSize: 11, fontWeight: 600, marginBottom: 2,
        border: `1.5px ${isPublished ? 'solid' : 'dashed'} ${baseBorder}`,
        opacity: isPublished ? 1 : 0.78,
        cursor: draggable ? 'grab' : 'pointer',
        whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
      }}>
      {fmtClock(shift.start_time)}–{fmtClock(shift.end_time)}
      {shift.break_minutes ? (
        <span title={shift.break_paid ? `Paid ${shift.break_minutes}-min break` : `Unpaid ${shift.break_minutes}-min break`}
              style={{ marginLeft: 3, fontSize: 9, color: shift.break_paid ? '#558b2f' : '#bf360c' }}>
          {shift.break_paid ? '☕' : '🍽'}{shift.break_minutes}
        </span>
      ) : null}
      {hasWarn && <span style={{ color: '#ef6c00', marginLeft: 3 }}>⚠</span>}
      {isSquare && <span style={{ color: '#9e9e9e', marginLeft: 3, fontSize: 9 }}>SQ</span>}
      {isPublished && !isSquare && <span style={{ color: '#1b5e20', marginLeft: 3, fontSize: 9 }}>✓</span>}
    </div>
  );
}
